import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './loader/loader.component';
import { QuantityPipe } from '../pipes/quantity.pipe';
import { DateTimeUtcPipePipe } from '../pipes/date-time-utc-pipe.pipe';
import { MaskTextPipe } from '../pipes/mask-text.pipe';
import { PharmNumberformatPipe } from '../pipes/pharm-numberformat.pipe';
import { ErrorPopupComponent } from '../myPrimeRx/components/error-popup/error-popup.component';
import { HeaderComponent } from '../myPrimeRx/components/header/header.component';
import { FooterComponent } from '../myPrimeRx/components/footer/footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MprxDatePickerComponent } from './mprx-date-picker/mprx-date-picker.component';
import { MprxInputComponent } from './mprx-input/mprx-input.component';
import { NgbDateParserFormatter, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateCustomParserFormatter } from '../myPrimeRx/components/utils/date-custom-parse.util';


@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    LoaderComponent,
    QuantityPipe,
    DateTimeUtcPipePipe,
    MaskTextPipe,
    PharmNumberformatPipe,
    ErrorPopupComponent,
    MprxDatePickerComponent,
    MprxInputComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbDatepickerModule
  ],
  exports:[
    HeaderComponent,
    FooterComponent,
    LoaderComponent,
    QuantityPipe,
    DateTimeUtcPipePipe,
    MaskTextPipe,
    PharmNumberformatPipe,
    ErrorPopupComponent,
    MprxInputComponent,
    MprxDatePickerComponent
  ],
   providers: [
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter }
  ]
})
export class SharedModule { }
